import React, { createContext, useContext, useEffect, useState } from 'react';

// Vietnamese translations cho UI customer-facing.
// Key = English string (giống code), value = Vietnamese.
// Cần thêm string mới: chỉ cần add entry vào VI map, code dùng key tiếng Anh như trước.
const VI = {
  // Login
  'LOGIN CODE': 'MÃ ĐĂNG NHẬP',
  'PASSWORD': 'MẬT KHẨU',
  'Authenticating...': 'Đang xác thực...',
  'Sign in →': 'Đăng nhập →',
  'CHECKOUT SYSTEM': 'HỆ THỐNG THEO DÕI VẬN CHUYỂN',
  'Enter password...': 'Nhập mật khẩu...',

  // Topbar
  'Sign out': 'Đăng xuất',
  'MY SHIPMENTS': 'KIỆN HÀNG CỦA TÔI',
  'Hello, {name}': 'Xin chào, {name}',

  // Tabs
  'Register': 'Đăng ký',
  'Shipments': 'Kiện hàng',
  'Find code': 'Tìm mã',

  // Find code tab
  'Multiple codes (exact match)': 'Nhiều mã (khớp chính xác)',
  'Suggest by partial code': 'Gợi ý theo một phần mã',
  'Paste multiple codes here, separated by spaces or newlines...': 'Dán nhiều mã ở đây, cách nhau bằng dấu cách hoặc xuống dòng...',
  'Searching...': 'Đang tìm...',
  '🔍 Search': '🔍 Tìm',
  'Results — {got}/{total} codes received': 'Kết quả — {got}/{total} mã đã nhận',
  'Type a partial code (e.g. last 4 digits). The system filters your shipments — useful when you don\'t remember the full code.': 'Gõ một phần mã (ví dụ 4 số cuối tracking). Hệ thống sẽ lọc trong kiện của bạn — hữu ích khi không nhớ chính xác mã.',
  'Type at least 4 characters...': 'Gõ ít nhất 4 ký tự...',
  'Type {n} more character(s)...': 'Gõ thêm {n} ký tự nữa...',
  'No shipments containing "{q}" in your list': 'Không tìm thấy kiện nào chứa "{q}" trong danh sách của bạn',
  'Found {n} shipments containing "{q}"': 'Tìm thấy {n} kiện chứa "{q}"',

  // Register tab
  'Paste tracking codes or customer orders here. Status updates automatically when the warehouse scans.': 'Dán mã tracking hoặc customer order vào đây. Trạng thái sẽ tự cập nhật khi kho scan.',
  'Tip — speed up tracking': 'Mẹo — kiện hàng tự gán nhanh hơn',
  'Add your code ({code}) at the end of the recipient name on each package, separated by a space.': 'Hãy thêm mã của bạn ({code}) vào cuối tên người nhận trên mỗi kiện, cách bằng khoảng trắng.',
  'Example': 'Ví dụ',
  'Paste multiple codes, separated by spaces or newlines...': 'Dán nhiều mã, cách nhau bằng dấu cách hoặc xuống dòng...',
  '-- Pick warehouse --': '-- Chọn kho --',
  'Please pick a warehouse!': 'Vui lòng chọn kho!',
  'Saving...': 'Đang lưu...',
  '📋 Register': '📋 Đăng ký',
  'Registration result': 'Kết quả đăng ký',
  '✅ Already in warehouse': '✅ Kho đã nhận',
  '⚠ Already registered': '⚠ Đã đăng ký trước',
  '❌ Claimed by another customer': '❌ Đã thuộc khách khác',
  '⏳ Waiting': '⏳ Chờ scan',
  'Registered codes ({n})': 'Mã đã đăng ký ({n})',
  '⏳ Updating...': '⏳ Đang cập nhật...',
  '🔄 Update status': '🔄 Cập nhật trạng thái',
  '✅ Updated — {updated}/{total} codes arrived': '✅ Đã cập nhật — {updated}/{total} mã đã về',
  'Loading...': 'Đang tải...',
  'No codes registered yet': 'Chưa đăng ký mã nào',
  '✅ Arrived': '✅ Đã đến',
  '⏳ Waiting scan': '⏳ Chờ scan',

  // Shipments tab
  '✕ Clear filter': '✕ Bỏ lọc',
  'No shipments': 'Không có kiện nào',
  'Awaiting flight': 'Đang chờ bay',
  'leftover from previous flights, grouped for this week\'s flight': 'còn lại từ chuyến trước, gom lại bay chuyến tuần này',
  'Newly arrived': 'Mới về kho',
  'just scanned, not yet scheduled': 'mới scan, chưa lên chuyến',
  'Ready to fly': 'Sẵn sàng bay',
  'arrived at main warehouse, will fly this week': 'đã ở kho chính, sẽ bay trong tuần',
  'At main warehouse': 'Hàng đang ở kho chính',
  'at main warehouse, will fly soon': 'đang ở kho chính, sắp bay về VN',
  'Awaiting transfer': 'Chờ chuyển kho',
  'at Kho 2 / Kho 3, pending transfer to main warehouse': 'ở Kho 2 / Kho 3, chờ chuyển lên kho chính',
  'Flown to Vietnam': 'Hàng đã bay về Việt Nam',
  'Holding at warehouse': 'Đang giữ lại kho',
  'held by your request, will ship later': 'theo yêu cầu của bạn, sẽ về sau',
  'On flight': 'Đã lên chuyến',
  'pick a flight to see the shipment list': 'chọn chuyến để xem danh sách kiện',
  'Pick a flown flight (click or type to search)...': 'Chọn chuyến đã bay (click hoặc gõ để tìm)...',
  '{n} shipments': '{n} kiện',
  '{n} lon': '{n} lon',
  'No shipments on flight {name}': 'Không có kiện nào trên chuyến {name}',

  // Card / detail
  'Tracking': 'Tracking',
  'Weight': 'Cân nặng',
  'Warehouse': 'Kho',
  'Flight': 'Chuyến bay',
  'Flights': 'Chuyến bay',
  'Recipient': 'Người nhận',
  'Not assigned': 'Chưa gán',
  'Count (staff)': 'Số lượng (NV xác nhận)',
  'Count (AI)': 'Số lượng (AI đếm)',
  '⚠ Shipment not registered. Please go to the 📋 REGISTER CODES tab and register this tracking code so the warehouse can confirm it as yours.': '⚠ Kiện chưa được đăng ký. Vui lòng sang tab 📋 ĐĂNG KÝ MÃ và đăng ký mã tracking này để kho xác nhận đúng kiện của bạn.',
  '⏳ Not scanned': '⏳ Chưa scan',
  'Please wait up to 48 hours. If still missing after 48h, contact SDC staff for assistance.': 'Vui lòng đợi đến 48 tiếng. Sau 48h vẫn chưa thấy, liên hệ nhân viên SDC để được hỗ trợ.',
  '🔗 Registered': '🔗 Đã đăng ký',
  '⚠ Not registered': '⚠ Chưa đăng ký',
  'Flown': 'Đã bay',
  'Pending': 'Chưa bay',
  '📦 Inside': '📦 Ảnh bên trong',
  '📦 Inside photos': '📦 Ảnh bên trong',
  'LABEL IMAGE': 'ẢNH LABEL',
  'Label image': 'Ảnh label',

  // InsideImagesModal
  'Inside photos': 'Ảnh bên trong',
  'No inside photos': 'Chưa có ảnh bên trong',
  'Click to zoom / rotate': 'Click để zoom / xoay',
  '{n} inside photos': '{n} ảnh bên trong',
  'Inside · {tracking}': 'Bên trong · {tracking}',
  'Inside': 'Bên trong',
};

const LANGS = ['en', 'vi'];
const STORAGE_KEY = 'kdx_lang';

const LanguageContext = createContext({
  lang: 'en',
  setLang: () => {},
});

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      return LANGS.includes(saved) ? saved : 'en';
    } catch { return 'en'; }
  });

  const setLang = (l) => {
    if (!LANGS.includes(l)) return;
    setLangState(l);
    try { localStorage.setItem(STORAGE_KEY, l); } catch {}
  };

  useEffect(() => {
    document.documentElement.setAttribute('lang', lang);
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  return useContext(LanguageContext);
}

// Hook trả về function t(key, params?) đã bound vào ngôn ngữ hiện tại.
// Dùng: const t = useT(); t('Sign in →'); t('Hello, {name}', { name: 'A' })
export function useT() {
  const { lang } = useLang();
  return (key, params) => {
    let result = lang === 'vi' ? (VI[key] ?? key) : key;
    if (params) {
      for (const k in params) {
        result = result.split(`{${k}}`).join(String(params[k]));
      }
    }
    return result;
  };
}
